import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * Writes scrid query parameter to localStorage if present
 */
export const usePersistentScrid = () => {
  const router = useRouter();

  useEffect(() => {
    const { scrid } = router.query;
    if (scrid) {
      const createdAt = Date.now();
      localStorage.setItem(
        'scrid',
        JSON.stringify({
          createdAt,
          expiresAt: createdAt + 1000 * 60 * 60 * 6,
          value: scrid.toString(),
        }),
      );
    }
  }, [router.query]);
};
